import { ref } from 'vue'
import { normalizeBaseCatalog } from '@/common/normalize/normalize-base-catalog'
import { apiRequest } from '@/common/utils/request.common'
import { HTTP_METHOD_GET } from '@/common/utils/request.const'

export const useCatalog = () => {
  const contextList = ref([])
  const topContext = ref({})

  /**
   * 카탈로그 데이터를 가져온다.
   * @param url
   * @returns {Promise<{data: undefined|*}>}
   */
  const getCatalog = async (url = '') => {
    try {
      const response = await apiRequest({
        url: `https://${url}`,
        method: HTTP_METHOD_GET,
      })

      if (!response) {
        return { data: undefined }
      }

      response.data = normalizeBaseCatalog(response?.data?.data)
      contextList.value = response.data?.contextList
      topContext.value = response.data?.topContext

      return response
    } catch (error) {
      console.error(`Error in getCatalog: ${error}`)
    }
  }

  return {
    contextList,
    topContext,
    getCatalog,
  }
}
